import { usePlatformAlerts } from '../context/PlatformAlertsContext';

/**
 * Toast notifications via the global platform alert (fixed Snackbar).
 * The returned `Toast` is a no-op fragment — mount is optional for backwards compatibility.
 */
export const useToast = () => {
  const { showPlatformAlert } = usePlatformAlerts();

  const showToast = (message, severity = 'info') => {
    showPlatformAlert(message, severity);
  };

  const Toast = () => null;

  return { showToast, Toast };
};

export default useToast;
